import type { LocaleBundle } from '../types.js'

export const ru: LocaleBundle = {
  code: 'ru',
  name: 'Русский',
  dict: {
    'common:appName': 'Modern Admin',
    'common:home': 'Главная',
    'common:search': 'Поиск',
    'common:loading': 'Загрузка…',
    'common:save': 'Сохранить',
    'common:cancel': 'Отмена',
    'common:delete': 'Удалить',
    'common:create': 'Создать',
    'common:edit': 'Редактировать',
    'common:show': 'Просмотр',
    'common:back': 'Назад',
    'common:noRecords': 'Записей не найдено.',
    'common:noRecordsHint': 'Создайте новую запись «{resource}», чтобы начать.',
    'common:noMatchingRecords': 'Нет записей, соответствующих фильтрам.',
    'common:clearFilters': 'Сбросить фильтры',
    'common:confirmDelete': 'Удалить запись?',
    'common:confirmAction': 'Подтвердите действие',
    'common:confirm': 'Подтвердить',
    'common:perPage': 'На странице',
    'common:page': 'Страница',
    'common:of': 'из',
    'common:total': 'Всего',
    'auth:login': 'Войти',
    'auth:logout': 'Выйти',
    'auth:email': 'Email',
    'auth:password': 'Пароль',
    'auth:loginFailed': 'Неверные данные.',
    'errors:notFound': 'Не найдено.',
    'errors:forbidden': 'Нет доступа к этому ресурсу.',
    'errors:server': 'Что-то пошло не так. Повторите попытку.',
    'common:resources': 'Ресурсы',
    'common:actions': 'Действия',
    'action:notFound': 'Действие «{action}» недоступно для этого ресурса.',
    'action:componentMissing': 'Компонент «{component}» не зарегистрирован.',
    'action:componentMissingHint': 'Зарегистрируйте его в ComponentLoader, передаваемом в <ModernAdminProvider components={…}>.',
    'action:loadFailed': 'Не удалось загрузить действие.',
    'common:new': 'Создать',
    'common:rowsPerPage': 'Строк на странице',
    'common:filter': 'Фильтр {label}…',
    'validation:required': 'Поле «{label}» обязательно',
    'validation:invalidNumber': 'Поле «{label}» должно быть числом',
    'validation:invalidInteger': 'Поле «{label}» должно быть целым числом',
    'validation:invalidEmail': 'Поле «{label}» должно быть корректным email',
    'validation:invalidUrl': 'Поле «{label}» должно быть корректной ссылкой',
    'validation:invalidDate': 'Поле «{label}» должно быть корректной датой',
    'validation:invalidUuid': 'Поле «{label}» должно быть корректным UUID',
    'validation:tooShort': 'Поле «{label}» должно содержать не менее {min} символов',
    'validation:tooLong': 'Поле «{label}» должно содержать не более {max} символов',
    'validation:notInList': 'Поле «{label}» содержит недопустимое значение',
    'validation:emptySelection': 'Выберите хотя бы одно значение для «{label}»',
    'toast:created': 'Запись успешно создана',
    'toast:saved': 'Изменения сохранены',
    'toast:deleted': 'Запись удалена',
    'toast:createFailed': 'Не удалось создать запись',
    'toast:saveFailed': 'Не удалось сохранить изменения',
    'toast:deleteFailed': 'Не удалось удалить запись',
    'toast:loadFailed': 'Не удалось загрузить данные',
    'toast:validationFailed': 'Исправьте ошибки и попробуйте снова',
    'common:close': 'Закрыть',
    'common:export': 'Экспорт',
    'export:title': 'Экспорт записей',
    'export:description': 'Скачать все подходящие записи ресурса «{resource}» одним файлом.',
    'export:csvHint': 'Значения через запятую',
    'export:jsonHint': 'Структурированный JSON-массив',
    'export:downloading': 'Готовим файл…',
    'export:progress': 'Загружено {loaded} из {total}…',
    'export:exported': 'Экспортировано записей: {count}',
    'export:exportFailed': 'Не удалось экспортировать записи',
    'common:apply': 'Применить',
    'common:clear': 'Очистить',
    'common:filters': 'Фильтры',
    'common:columns': 'Колонки',
    'common:toggleColumns': 'Видимые колонки',
    'common:openMenu': 'Открыть меню',
    'common:refresh': 'Обновить',
    'common:copy': 'Копировать',
    'common:copied': 'Скопировано!',
    'common:applyFilters': 'Применить фильтры',
    'common:clearAll': 'Сбросить все',
    'common:any': 'Любое',
    'common:yes': 'Да',
    'common:no': 'Нет',
    'common:filterPlaceholder': 'Фильтр…',
    'common:loadFailed': 'Не удалось загрузить: {error}',
    'common:theme': 'Тема',
    'common:language': 'Язык',
    'common:toggleTheme': 'Переключить тему',
    'common:clearSelection': 'Очистить выбор',
    'common:searchPlaceholder': 'Поиск…',
    'home:searchResources': 'Поиск ресурсов…',
    'home:noMatchingResources': 'Подходящие ресурсы не найдены.',
    'globalSearch:title': 'Глобальный поиск',
    'globalSearch:description': 'Поиск по всем ресурсам и записям.',
    'globalSearch:trigger': 'Поиск…',
    'globalSearch:placeholder': 'Поиск по всем ресурсам…',
    'globalSearch:hint': 'Начните вводить, чтобы искать по всем ресурсам.',
    'globalSearch:noResults': 'Ничего не найдено.',
    'globalSearch:error': 'Не удалось выполнить поиск. Попробуйте ещё раз.',
    'globalSearch:hotkey': 'Открыть глобальный поиск',
    'globalSearch:matchedIn': 'в {field}',
    'globalSearch:recent': 'Недавние запросы',
    'globalSearch:clearRecent': 'Очистить',
    'globalSearch:showAllIn': 'Показать все в {resource}',
    'common:pageOf': 'Страница {page} из {total}',
    'common:firstPage': 'Первая страница',
    'common:previousPage': 'Предыдущая страница',
    'common:nextPage': 'Следующая страница',
    'common:lastPage': 'Последняя страница',
    'common:recordsCount': 'Всего записей: {count}',
    'common:selectedCount': 'Выбрано: {count}',
    'common:selectRow': 'Выбрать строку',
    'common:selectAll': 'Выбрать все',
    'common:deleteSelected': 'Удалить выбранные',
    'common:bulkDeleteConfirm': 'Удалить выбранные записи ({count})?',
    'toast:bulkDeleted': 'Удалено записей: {count}',
    'toast:bulkDeleteFailed': 'Не удалось удалить записи',
    'common:from': 'От',
    'common:to': 'До',
    'common:sortBy': 'Сортировка',
    'common:next': 'Вперёд',
    'common:previous': 'Назад',
    'common:relatedRecords': 'Связанные записи',
    'common:viewAll': 'Все записи',
    'common:noRelatedRecords': 'Связанных записей нет.',
    'common:shortcutsHelp': 'Сочетания клавиш',
    'common:shortcutsEmpty': 'На этом экране нет доступных сочетаний.',
    'common:preview': 'Просмотр',
    'common:download': 'Скачать',
    'common:openInNewTab': 'Открыть в новой вкладке',
    'common:format': 'Форматировать',
    'common:invalidJson': 'Некорректный JSON',
    'common:showPassword': 'Показать пароль',
    'common:hidePassword': 'Скрыть пароль',
    'auth:title': 'Вход',
    'auth:subtitle': 'Введите email и пароль для входа',
    'auth:tagline': 'Современная админ-панель для любого стека.',
    'auth:orContinueWith': 'Или войти через',
    'auth:continueWith': 'Войти через {provider}',
    'common:chooseFile': 'Выбрать файл',
    'common:chooseFiles': 'Выбрать файлы',
    'common:dragAndDrop': 'Перетащите или',
    'common:chooseAFile': 'выберите файл',
    'common:addMoreFiles': 'добавить файлы',
    'common:uploading': 'Загрузка…',
    'common:uploadingFile': 'Загрузка {name}…',
    'common:removeFile': 'Удалить файл',
    'common:uploadFailed': 'Ошибка загрузки',
    'common:dismiss': 'Закрыть',
    'common:openCalendar': 'Открыть календарь',
    'common:time': 'Время',
    'common:downloadFailed': 'Ошибка скачивания',
    'richtext:bold': 'Жирный',
    'richtext:italic': 'Курсив',
    'richtext:strikethrough': 'Зачёркнутый',
    'richtext:inlineCode': 'Код',
    'richtext:heading': 'Заголовок {level}',
    'richtext:bulletList': 'Маркированный список',
    'richtext:numberedList': 'Нумерованный список',
    'richtext:blockquote': 'Цитата',
    'richtext:horizontalRule': 'Горизонтальная линия',
    'richtext:insertLink': 'Вставить ссылку',
    'richtext:undo': 'Отменить',
    'richtext:redo': 'Повторить',
    'richtext:source': 'Исходник ({format})',
    'richtext:splitView': 'Разделённый вид',
    'richtext:visualEditor': 'Визуальный редактор',
    'richtext:fullscreen': 'Полный экран',
    'richtext:exitFullscreen': 'Выйти из полного экрана',
    'richtext:urlPrompt': 'URL',
    'common:saving': 'Сохранение…',
    'common:done': 'Готово',
    'settings:menuItem': 'Настройки',
    'settings:noSectionsConfigured': 'В этом развёртывании нет доступных разделов настроек.',
    'settings:apiKeys.title': 'API-ключи',
    'settings:apiKeys.description': 'Программные токены доступа к API админ-панели. Каждый ключ имеет набор прав, ограничивающий доступные ресурсы и действия.',
    'settings:apiKeys.actions.create': 'Создать ключ',
    'settings:apiKeys.actions.edit': 'Редактировать',
    'settings:apiKeys.actions.revoke': 'Отозвать',
    'settings:apiKeys.empty.title': 'Ключей ещё нет',
    'settings:apiKeys.empty.description': 'Создайте первый ключ, чтобы предоставить программный доступ.',
    'settings:apiKeys.columns.name': 'Название',
    'settings:apiKeys.columns.start': 'Префикс',
    'settings:apiKeys.columns.permissions': 'Права',
    'settings:apiKeys.columns.expiresAt': 'Истекает',
    'settings:apiKeys.columns.enabled': 'Активен',
    'settings:apiKeys.columns.actions': 'Действия',
    'settings:apiKeys.lastUsed': 'Использован {date}',
    'settings:apiKeys.expiresNever': 'Никогда',
    'settings:apiKeys.permissions.resource': 'Ресурс',
    'settings:apiKeys.permissions.actions': 'Действия',
    'settings:apiKeys.permissions.selectAll': 'Выбрать все',
    'settings:apiKeys.permissions.clearAll': 'Снять все',
    'settings:apiKeys.permissions.none': 'Нет прав',
    'settings:apiKeys.permissions.summary': 'Ресурсов: {resources} · действий: {actions}',
    'settings:apiKeys.permissions.noResources': 'Нет зарегистрированных ресурсов.',
    'settings:apiKeys.permissions.selectAllResources': 'Выбрать все ресурсы и действия',
    'settings:apiKeys.permissions.clearAllResources': 'Снять все ресурсы и действия',
    'settings:apiKeys.editor.titleCreate': 'Новый API-ключ',
    'settings:apiKeys.editor.titleEdit': 'Изменить API-ключ',
    'settings:apiKeys.editor.description': 'Дайте ключу понятное название и выдайте только те ресурсы и действия, которые ему действительно нужны.',
    'settings:apiKeys.editor.name': 'Название',
    'settings:apiKeys.editor.namePlaceholder': 'напр. CI-бот деплоя',
    'settings:apiKeys.editor.expiresInDays': 'Срок действия (дней)',
    'settings:apiKeys.editor.expiresPlaceholder': 'без срока',
    'settings:apiKeys.editor.expiresHint': 'Оставьте пустым, чтобы ключ не истекал. Максимум 3650 дней.',
    'settings:apiKeys.editor.permissions': 'Права',
    'settings:apiKeys.editor.selectedActions': 'Выбрано: {count}',
    'settings:apiKeys.created.title': 'API-ключ создан',
    'settings:apiKeys.created.description': 'Скопируйте ключ сейчас — он больше не будет показан.',
    'settings:apiKeys.created.warning': 'Это единственный раз, когда виден полный ключ. Сохраните его в надёжном месте.',
    'settings:apiKeys.created.reveal': 'Показать ключ',
    'settings:apiKeys.created.hide': 'Скрыть ключ',
    'settings:apiKeys.created.copy': 'Копировать',
    'settings:apiKeys.created.copied': 'Скопировано',
    'settings:apiKeys.notice.revoked': 'API-ключ отозван',
    'settings:apiKeys.notice.updated': 'API-ключ обновлён',
    'settings:apiKeys.notice.copied': 'Скопировано в буфер обмена',
    'settings:apiKeys.notice.copyFailed': 'Не удалось скопировать в буфер обмена',
    'settings:apiKeys.confirmRevoke.title': 'Отозвать API-ключ',
    'settings:apiKeys.confirmRevoke.description': 'Отозвать «{name}»? Все сервисы, использующие этот ключ, сразу перестанут работать.',
    'settings:webhooks.title': 'Вебхуки',
    'settings:webhooks.description': 'Отправляйте подписанные HTTP-уведомления при создании, изменении или удалении записей.',
    'settings:webhooks.actions.create': 'Новый вебхук',
    'settings:webhooks.actions.test': 'Тест',
    'settings:webhooks.notice.saved': 'Вебхук сохранён',
    'settings:webhooks.notice.deleted': 'Вебхук удалён',
    'settings:webhooks.notice.testQueued': 'Тестовое уведомление поставлено в очередь',
    'settings:webhooks.confirmDelete.title': 'Удалить вебхук',
    'settings:webhooks.confirmDelete.description': 'Удалить «{name}»? История доставок этого вебхука тоже будет удалена.',
    'settings:webhooks.empty.title': 'Вебхуков пока нет',
    'settings:webhooks.empty.description': 'Создайте вебхук, чтобы уведомлять внешние системы об изменениях в админке.',
    'settings:webhooks.columns.name': 'Название',
    'settings:webhooks.columns.resource': 'Ресурс',
    'settings:webhooks.columns.events': 'События',
    'settings:webhooks.columns.enabled': 'Включён',
    'settings:webhooks.columns.actions': 'Действия',
    'settings:webhooks.deliveries.title': 'Последние доставки',
    'settings:webhooks.deliveries.status': 'Статус',
    'settings:webhooks.deliveries.event': 'Событие',
    'settings:webhooks.deliveries.attempt': 'Попытка',
    'settings:webhooks.deliveries.response': 'Ответ',
    'settings:webhooks.deliveries.createdAt': 'Создано',
    'settings:webhooks.editor.titleCreate': 'Новый вебхук',
    'settings:webhooks.editor.titleEdit': 'Редактировать вебхук',
    'settings:webhooks.editor.description': 'Выберите URL, события, фильтры и поля payload.',
    'settings:webhooks.editor.name': 'Название',
    'settings:webhooks.editor.url': 'URL',
    'settings:webhooks.editor.resource': 'Ресурс',
    'settings:webhooks.editor.allResources': 'Все ресурсы',
    'settings:webhooks.editor.secret': 'Секрет подписи',
    'settings:webhooks.editor.enabled': 'Включён',
    'settings:webhooks.editor.events': 'События',
    'settings:webhooks.editor.payloadFields': 'Поля payload',
    'settings:webhooks.editor.payloadFieldsHint': 'Ограничьте payload конкретными полями. Оставьте все не выбранными, чтобы включить полную запись. Удобно для скрытия чувствительных данных.',
    'settings:webhooks.editor.headers': 'Заголовки',
    'settings:webhooks.editor.headersHint': 'HTTP-заголовки, отправляемые с каждым запросом.\n\nПример:\n{\n  "Authorization": "Bearer <token>",\n  "X-Source": "modern-admin"\n}\n\nПодходит для токенов авторизации и подписей.',
    'settings:webhooks.editor.filters': 'Фильтры',
    'settings:webhooks.editor.filtersHint': 'Доставлять только когда запись соответствует всем условиям (AND). Оставьте пустым для доставки по всем событиям.\n\nПример:\n{\n  "status": "published",\n  "role": "admin"\n}\n\nПримечание: события удаления игнорируют фильтры, т.к. записи уже нет.',
    'settings:webhooks.editor.secretHint': 'Случайная строка для подписи доставок через HMAC-SHA256. Проверяйте заголовок X-Webhook-Signature на сервере.',
    'chart:dashboard': 'Дашборд',
    'chart:addChart': 'Добавить график',
    'chart:newChart': 'Новый график',
    'chart:editChart': 'Редактировать график',
    'chart:deleteChart': 'Удалить график',
    'chart:noCharts': 'Нет графиков',
    'chart:noChartsHint': 'Добавьте график для мониторинга данных.',
    'chart:addGroup': 'Добавить группу',
    'chart:newGroup': 'Новая группа',
    'chart:editGroup': 'Редактировать группу',
    'chart:deleteGroup': 'Удалить группу',
    'chart:saveGroup': 'Сохранить группу',
    'chart:groupName': 'Название группы',
    'chart:groupNamePlaceholder': 'напр. Метрики продаж',
    'chart:groupNameRequired': 'Укажите название группы',
    'chart:groupOrder': 'Порядок группы',
    'chart:order': 'Порядок',
    'chart:orderHint': 'Меньшие значения отображаются первыми.',
    'chart:moveToGroup': 'Переместить в группу',
    'chart:moveChart': 'Переместить график',
    'chart:moveGroup': 'Группа',
    'chart:moveNoGroups': 'Групп ещё нет.',
    'chart:moveNoGroupsHint': 'Сначала создайте группу для организации графиков.',
    'chart:deleteChartConfirm': 'Удалить этот график?',
    'chart:deleteChartConfirmHint': 'Это действие нельзя отменить.',
    'chart:deleteGroupConfirm': 'Удалить эту группу?',
    'chart:deleteGroupConfirmHint': 'Группа и все графики в ней ({count}) будут удалены безвозвратно.',
    'chart:title': 'Название',
    'chart:titlePlaceholder': 'напр. Новые пользователи в день',
    'chart:untitled': 'Без названия',
    'chart:chartType': 'Тип графика',
    'chart:resource': 'Ресурс',
    'chart:groupBy': 'Группировать по',
    'chart:step': 'Шаг',
    'chart:metric': 'Метрика',
    'chart:aggregateField': 'Поле для агрегации',
    'chart:selectField': 'Выберите поле…',
    'chart:saveChart': 'Сохранить график',
    'chart:typeLine': 'Линейный',
    'chart:typeArea': 'Площадной',
    'chart:typeBar': 'Столбчатый',
    'chart:typePie': 'Круговой',
    'chart:stepDay': 'День',
    'chart:stepWeek': 'Неделя',
    'chart:stepMonth': 'Месяц',
    'chart:stepYear': 'Год',
    'chart:metricCount': 'Количество',
    'chart:metricSum': 'Сумма',
    'chart:metricAvg': 'Среднее',
    'chart:noData': 'Нет данных за выбранный период',
    'chart:loadError': 'Не удалось загрузить данные графика',
    'chart:value': 'Значение',
    'dashboard:vis': 'Визуализация',
    'dashboard:visKpi': 'KPI',
    'dashboard:visLine': 'Линейный',
    'dashboard:visArea': 'Площадной',
    'dashboard:visBar': 'Столбчатый',
    'dashboard:visPie': 'Круговой',
    'dashboard:metricCount': 'Количество',
    'dashboard:metricSum': 'Сумма',
    'dashboard:metricAvg': 'Среднее',
    'dashboard:metricMin': 'Минимум',
    'dashboard:metricMax': 'Максимум',
    'dashboard:builder.range': 'Период',
    'dashboard:builder.filters': 'Фильтры',
    'dashboard:builder.filtersHint': 'Сузить выборку перед агрегацией. Отметьте фильтр, чтобы вывести его над графиком как быстрый фильтр.',
    'dashboard:builder.quickFilterHint': 'Показывать этот фильтр над графиком на дашборде.',
    'dashboard:builder.quickFilterToggle': 'Вывести {field} как быстрый фильтр',
    'dashboard:range.7d': '7 дн.',
    'dashboard:range.30d': '30 дн.',
    'dashboard:range.90d': '90 дн.',
    'dashboard:range.1y': '1 год',
    'dashboard:range.all': 'Всё время',
    'dashboard:range.custom': 'Свой',
    'dashboard:widget.previousPeriod': 'к предыдущему периоду',
    'dashboard:widget.deltaUp': '+{value} ({percent}%)',
    'dashboard:widget.deltaDown': '−{value} ({percent}%)',
    'dashboard:widget.deltaFlat': '{value} ({percent}%)',
    'dashboard:widget.shrink': 'Уменьшить до половины',
    'dashboard:widget.expand': 'Растянуть на всю ширину',
    'dashboard:widget.toggleSql': 'Показать SQL',
    'dashboard:widget.unsupported': 'Графики для вашей базы данных пока не поддерживаются.',
    'dashboard:widget.truncatedWarning': 'Показаны неполные данные — слишком много строк для агрегации всего диапазона.',
    'dashboard:widget.showAll': 'Показать все',
    'dashboard:widget.hideAll': 'Скрыть все',
    'dashboard:seriesTotal': 'Всего',
    'dashboard:seriesOther': 'Прочее',
    'dashboard:seriesNull': 'Пусто',
    'dashboard:builder.dateField': 'Поле даты',
    'dashboard:builder.dateFieldHint': 'Бакетирование по оси X использует это поле даты.',
    'dashboard:builder.secondaryGroupBy': 'Разбивка',
    'dashboard:builder.noBreakdown': 'Один ряд',
    'dashboard:builder.topN': 'Макс. рядов',
    'dashboard:builder.width': 'Ширина',
    'dashboard:width.half': 'Половина',
    'dashboard:width.full': 'Полная',
    'dashboard:builder.comparePrevious': 'Сравнить с предыдущим периодом',
    'dashboard:builder.comparePreviousHint': 'Накладывает предыдущий период той же длины пунктирной линией и показывает изменение рядом с заголовком.',
    'dashboard:builder.comparePreviousDisabled': 'Недоступно при разбивке.',
    'dashboard:builder.transform': 'Преобразование значений',
    'dashboard:builder.transformHint': 'Применяется к значениям перед отображением — например, разделить на 100, чтобы показать центы как доллары.',
    'dashboard:builder.transformAdd': 'Добавить шаг',
    'dashboard:builder.transformRemove': 'Удалить шаг',
    'dashboard:builder.opDivide': 'Разделить на',
    'dashboard:builder.opMultiply': 'Умножить на',
    'dashboard:builder.opAdd': 'Прибавить',
    'dashboard:builder.opSubtract': 'Вычесть',
    'dashboard:builder.format': 'Формат значений',
    'dashboard:builder.formatStyle': 'Стиль',
    'dashboard:builder.formatNumber': 'Число',
    'dashboard:builder.formatCurrency': 'Валюта',
    'dashboard:builder.formatPercent': 'Проценты',
    'dashboard:builder.formatCurrencyCode': 'Код валюты',
    'dashboard:builder.formatDecimals': 'Знаков после запятой',
    'dashboard:builder.formatCompact': 'Компактные числа (12,5 тыс.)',
    'dashboard:builder.formatPrefix': 'Префикс',
    'dashboard:builder.formatSuffix': 'Суффикс',
    'dashboard:builder.color': 'Цвет серии',
    'dashboard:widget.previousSeries': '{label} (пред. период)',
    'dashboard:widget.editColors': 'Изменить цвета',
    'dashboard:widget.colorsTitle': 'Цвета серий',
    'dashboard:widget.colorCustom': 'Свой',
    'dashboard:widget.colorAuto': 'Авто',
    'dashboard:widget.colorPick': 'Выбрать цвет',
    'dashboard:builder.tabData': 'Данные',
    'dashboard:builder.tabDisplay': 'Отображение',
    'dashboard:builder.tabFilters': 'Фильтры',
    'dashboard:builder.filtersEmpty': 'У этого ресурса нет полей для фильтрации.',
    'history:revisions': 'Версии',
    'history:noRevisions': 'Версий пока нет',
    'history:loadError': 'Не удалось загрузить историю изменений',
    'history:revert': 'Откатить',
    'history:confirmRevert': 'Откатить запись к этой версии?',
    'history:revertSuccess': 'Версия восстановлена',
    'history:revertFailed': 'Не удалось восстановить версию',
    'history:unknownUser': 'Неизвестный пользователь',
    'history:changes': 'изменений',
    'history:compareTo': 'Сравнить с',
    'history:storedDiff': 'Изменения версии',
    'history:op.create': 'Создано',
    'history:op.update': 'Обновлено',
    'history:op.delete': 'Удалено',
    'diff:added': 'Добавлено',
    'diff:changed': 'Изменено',
    'diff:removed': 'Удалено',
    'diff:before': 'До',
    'diff:after': 'После',
    'diff:noChanges': 'Изменения полей не записаны',
    'audit:title': 'Активность',
    'audit:resource': 'Ресурс',
    'audit:action': 'Действие',
    'audit:recordId': 'ID записи',
    'audit:userId': 'ID пользователя',
    'audit:allResources': 'Все ресурсы',
    'audit:allActions': 'Все действия',
    'audit:noEvents': 'Активности пока нет',
    'audit:records': 'записей',
    'audit:loadError': 'Не удалось загрузить активность',
    'audit:by': 'автор: {user}',
    'audit:viewRecord': 'Открыть запись',
    'audit:viewChanges': 'Показать изменения',
    'audit:hideChanges': 'Скрыть изменения',
    'audit:noDiff': 'Детали изменений недоступны',
    'audit:loadDiffError': 'Не удалось загрузить изменения',
    'audit:action.new': 'Запись создана',
    'audit:action.edit': 'Запись обновлена',
    'audit:action.delete': 'Запись удалена',
    'audit:action.bulkDelete': 'Записи удалены',
    'audit:action.login': 'Вход выполнен',
    'audit:action.apiKeyCreate': 'API-ключ создан',
    'audit:action.apiKeyUpdate': 'API-ключ обновлён',
    'audit:action.apiKeyDelete': 'API-ключ удалён',
    'audit:virtualResource.auth': 'Аутентификация',
    'audit:virtualResource.apiKeys': 'API-ключи',
    'audit:prevPage': 'Назад',
    'audit:nextPage': 'Вперёд',
    'audit:dateRangePlaceholder': 'Выберите период',
    'keyValue:noMatches': 'Совпадений нет — нажмите Enter, чтобы оставить «{value}».',
    'aiAssistant:queue.cancel': 'Убрать из очереди',
    'aiAssistant:title': 'AI Помощник',
    'aiAssistant:fab.label': 'Открыть AI помощника',
    'aiAssistant:fab.short': 'AI',
    'aiAssistant:description': 'Задайте вопросы о записях, связях, отчётах и трендах данных.',
    'aiAssistant:notConfigured.title': 'Помощник не настроен',
    'aiAssistant:notConfigured.description': 'Добавьте ключ API OpenRouter в настройках, чтобы включить помощника (только чтение).',
    'aiAssistant:notConfigured.openSettings': 'Открыть настройки',
    'aiAssistant:tryAsking': 'Попробуйте спросить:',
    'aiAssistant:tryAsking.example1': 'У каких клиентов больше всего постов?',
    'aiAssistant:tryAsking.example2': 'Покажи недавно созданные записи ресурса.',
    'aiAssistant:tryAsking.example3': 'Объясни связи между конкретными записями.',
    'aiAssistant:thinking': 'Думаю',
    'aiAssistant:thinkingProgress': 'Думаю ({progress}%)',
    'aiAssistant:input.placeholder': 'Спросите о ваших данных…',
    'aiAssistant:input.hint': 'Enter — отправить · Shift+Enter — новая строка',
    'aiAssistant:send': 'Отправить сообщение',
    'aiAssistant:newChat': 'Новый чат',
    'aiAssistant:history': 'История чатов',
    'aiAssistant:history.empty': 'Предыдущих чатов нет',
    'aiAssistant:noText': 'Вот найденные связанные записи:',
    'aiAssistant:fallback.noToolResult': 'Запрос выполнен, но модель не вернула текстовый ответ. Уточните вопрос или включите debug-логи, чтобы проверить результат инструмента.',
    'aiAssistant:fallback.noRows': 'По этому запросу записи не найдены.',
    'aiAssistant:fallback.rowsFound': 'Найдено строк: {count}.',
    'aiAssistant:taskFailed': 'Задача AI помощника не выполнена',
    'aiAssistant:settings.title': 'AI Помощник',
    'aiAssistant:settings.description': 'Настройте плавающий чат-виджет, модель и серверное поведение помощника.',
    'aiAssistant:settings.enabled': 'Включён',
    'aiAssistant:settings.disabled': 'Выключен',
    'aiAssistant:settings.configured': 'Настроен',
    'aiAssistant:settings.apiKeyRequired': 'Требуется ключ API',
    'aiAssistant:settings.readOnly': 'Только чтение',
    'aiAssistant:settings.provider': 'Провайдер: {provider}',
    'aiAssistant:settings.enableLabel': 'Включить помощника',
    'aiAssistant:settings.enableHint': 'Управляет видимостью плавающего виджета и эндпоинта чата.',
    'aiAssistant:settings.modelLabel': 'Модель OpenRouter',
    'aiAssistant:settings.apiKeyLabel': 'Ключ API OpenRouter',
    'aiAssistant:settings.apiKeyHint': 'Оставьте пустым, чтобы сохранить уже сохранённый на сервере ключ.',
    'aiAssistant:settings.systemPromptLabel': 'Переопределение системного промпта',
    'aiAssistant:settings.systemPromptPlaceholder': 'Дополнительные инструкции под ваш проект (необязательно)',
    'aiAssistant:settings.accessTitle': 'Модель доступа',
    'aiAssistant:settings.accessDescription': 'Сейчас помощник ограничен инспекцией записей в режиме только чтения через действия ресурсов.',
    'aiAssistant:settings.futureToolsReady': 'Готов к будущим инструментам',
    'aiAssistant:settings.save': 'Сохранить настройки',
    'aiAssistant:settings.saving': 'Сохраняем…',
    'aiAssistant:settings.saved': 'Настройки AI помощника сохранены',
    'aiAssistant:settings.empty': 'Настройки недоступны.',
    'filter:op.co': 'Содержит',
    'filter:op.nco': 'Не содержит',
    'filter:op.sw': 'Начинается с',
    'filter:op.ew': 'Заканчивается на',
    'filter:op.eq': 'Равно',
    'filter:op.neq': 'Не равно',
    'filter:op.empty': 'Пусто',
    'filter:op.nempty': 'Не пусто',
    'filter:op.in': 'Одно из',
    'filter:op.gt': 'Больше',
    'filter:op.lt': 'Меньше',
    'filter:op.between': 'Между',
    'filter:searchValues': 'Поиск в списке…',
    'filter:selectAll': 'Выбрать всё',
    'filter:noValues': 'Значения не найдены',
    'common:newRecord': 'Новый {name}',
    'common:editRecord': 'Редактирование {name} #{id}',
    'common:themeLight': 'Светлая',
    'common:themeDark': 'Тёмная',
    'common:themeSystem': 'Системная',
    'common:ok': 'OK',
    'common:select': 'Выбрать…',
    'common:removeItem': 'Удалить {title}',
    'common:nSelectedAddMore': 'Выбрано {count} — добавить ещё',
    'common:pickRecords': 'Выбрать записи',
    'common:managePickRecords': 'Управлять выбором ({count})',
    'common:pickRecordsFrom': 'Выбрать из {name}',
    'common:draftRestored': 'Восстановлен несохранённый черновик',
    'common:undoDraftRestore': 'Отменить',
    'aiFill:button': 'ИИ-заполнение',
    'aiFill:dialogTitle': 'Заполнить форму по фото',
    'aiFill:dialogDescription': 'Загрузите изображение — ИИ извлечёт значения и заполнит форму.',
    'aiFill:fillButton': 'Распознать',
    'aiFill:processing': 'Распознавание изображения…',
    'aiFill:success': 'Заполнено полей: {count}',
    'aiFill:errorNoFields': 'У этого ресурса нет полей для ИИ-заполнения.',
    'aiFill:errorGeneric': 'Ошибка ИИ-заполнения: {message}',
    'aiFill:noValues': 'ИИ не смог извлечь ни одного значения с этого изображения.',
    'aiFill:applied': 'ИИ заполнил {count} поле(й). Можно отменить ниже.',
    'wizard:stepOf': 'Шаг {current} из {total}',
    'wizard:products.step1': 'Основные данные',
    'wizard:products.step2': 'Цены',
    'wizard:products.step3': 'Медиа и теги',
    'common:invalidValue': 'Недопустимое значение',
    'common:collapseSidebar': 'Свернуть боковую панель',
    'common:expandSidebar': 'Развернуть боковую панель',
    'common:toggleSidebar': 'Переключить боковую панель',
    'common:sidebarTitle': 'Боковая панель',
    'common:sidebarNavigation': 'Меню навигации',
    'cache:title': 'Кэш',
    'cache:description': 'Состояние кэша и производительность ресурсов на этой реплике.',
    'cache:load.error': 'Не удалось загрузить метрики кэша',
    'cache:load.retry': 'Повторить',
    'cache:reset.action': 'Сбросить метрики',
    'cache:reset.loading': 'Сброс метрик кэша…',
    'cache:reset.success': 'Метрики кэша сброшены',
    'cache:reset.error': 'Не удалось сбросить метрики кэша',
    'cache:metric.hitRate': 'Доля попаданий',
    'cache:metric.requests': 'Чтения кэша',
    'cache:metric.avgCompute': 'Среднее вычисление',
    'cache:metric.errors': 'Ошибки',
    'cache:unit.ms': '{value} мс',
    'cache:quarantine.title': 'Теги в карантине',
    'cache:quarantine.description': 'Для этих тегов кэш обходится, пока инвалидация не завершится успешно.',
    'cache:invalidate.title': 'Инвалидация кэша ресурса',
    'cache:invalidate.description': 'Удаляет списки и записи ресурса на всех настроенных репликах.',
    'cache:invalidate.resource': 'Ресурс',
    'cache:invalidate.action': 'Инвалидировать кэш',
    'cache:invalidate.loading': 'Инвалидация кэша…',
    'cache:invalidate.success': 'Кэш ресурса инвалидирован',
    'cache:invalidate.error': 'Не удалось инвалидировать кэш ресурса',
    'cache:table.title': 'Метрики по пространствам имён',
    'cache:table.empty': 'Активность кэша пока не зафиксирована.',
    'cache:instance': 'Реплика {id}',
    'cache:table.namespace': 'Пространство имён',
    'cache:table.resource': 'Ресурс',
    'cache:table.hits': 'Попадания',
    'cache:table.misses': 'Промахи',
    'cache:table.computes': 'Вычисления',
    'cache:table.coalesced': 'Объединено',
    'cache:table.errors': 'Ошибки',
  },
}
